<template>
    <j-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading" :maskClosable="false" :body-style="{ height: '800px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk" @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
        <a-spin :spinning="confirmLoading">
            <j-form-container :disabled="false">
                <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
                    <a-row :gutter="24">
                        <a-col :span="8">
                            <a-form-model-item :label="$t('设备类型')" prop="deviceType">
                                <!-- <a-input v-model="model.deviceType" placeholder="请输入设备类型"></a-input> -->
                                <j-dict-select-tag v-model="model.deviceType" :dictCode="'deviceType'" :showSearch="false" :placeholder="$t('请选择设备类型')" :disabled="disableSubmit" />
                                <!-- <a-select placeholder="请选择设备类型" v-model="model.deviceType">
                  <a-select-option :value="0">类型0</a-select-option>
                  <a-select-option :value="1">类型1</a-select-option>
                  <a-select-option :value="2">类型2</a-select-option>
                  <a-select-option :value="3">类型3</a-select-option>
                </a-select> -->
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-model-item :label="$t('设备名称')" prop="deviceName">
                                <a-input v-model="model.deviceName" :placeholder="$t('请输入设备名称')" :disabled="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-model-item :label="$t('设备编号')" prop="deviceNum">
                                <a-input v-model="model.deviceNum" :placeholder="$t('请输入设备编号')" :disabled="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="24">
                        <a-col :span="8">
                            <a-form-model-item :label="$t('设备描述')" prop="deviceDetail">
                                <a-input v-model="model.deviceDetail" :placeholder="$t('请输入设备描述')" :disabled="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="8">
                            <a-form-model-item :label="$t('设备经度')" prop="detectLongitude">
                                <a-input type="number" v-model="model.detectLongitude" :placeholder="$t('请输入设备经度')" :disabled="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-model-item :label="$t('设备纬度')" prop="detectLatitude">
                                <a-input type="number" v-model="model.detectLatitude" :placeholder="$t('请输入设备纬度')" :disabled="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-model-item :label="$t('图片附件上传')" prop="devicePictureUrl">
                                <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="model.devicePictureUrl" :disabled="disableSubmit"></j-image-upload>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-col :span="24">
                        <a-form-model-item label="" prop="">
                            <div style="width: 100%;height: 400px;" id="amapDiv">
                                <div style="display: flex;margin-bottom: 5px">
                                    <a-auto-complete v-model="searchAddresKeywords" :placeholder="$t('搜索地址')" @select="onSelect" :disabled="disableSubmit" :open="defaultOpen" v-if="!disableSubmit">
                                        <template slot="dataSource">
                                            <a-select-option v-for="item in localList" :key="item.uid">
                                                <div>{{ item.title }}</div>
                                                <div style="font-size: 12px;color: #999;">{{ item.address }}</div>
                                            </a-select-option>
                                        </template>
                                    </a-auto-complete>
                                    <a-button type="primary" icon="search" @click="handleSearch" style="margin-left: 10px">{{ $t('查询') }}</a-button>
                                </div>
                                <baidu-map v-if="visible" :center="center" :zoom="zoom" :style="{height: 380+'px'}" :scroll-wheel-zoom="scrollZoom" NavigationControlType="BMAP_NAVIGATION_CONTROL_LARGE" @ready="mapReady">
                                    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
                                </baidu-map>
                            </div>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-model-item :label="$t('备注')" prop="remark">
                            <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" :disabled="disableSubmit" />
                        </a-form-model-item>
                    </a-col>
                    <template v-if="model.resultDescription">
                        <a-row :gutter="24">
                            <a-col :span="8">
                                <a-form-model-item :label="$t('是否正常')" prop="isOk">
                                    <a-select :placeholder="$t('请选择是否正常')" v-model="model.isOk" :disabled="disableSubmit">
                                        <a-select-option :value="0">{{ $t('正常') }}</a-select-option>
                                        <a-select-option :value="1">{{ $t('异常') }}</a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-model-item :label="$t('结果描述')" prop="resultDescription">
                                    <a-textarea v-model="model.resultDescription" placeholder="" :rows="4" :disabled="disableSubmit" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                    </template>
                    </a-row>
                </a-form-model>
            </j-form-container>
        </a-spin>
    </j-modal>
</template>

<script>
// import {
//   JeecgListMixin
// } from '@/mixins/JeecgListMixin';
import {
    httpAction,
    getAction
} from '@/api/manage'
import {
    validateDuplicateValue
} from '@/utils/util'
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
export default {
    // mixins: [JeecgListMixin],
    name: 'deviceModal',
    components: {
        JImageUpload,
    },
    data() {
        return {
            title: '',
            width: 800,
            visible: false,
            disableSubmit: false,
            confirmLoading: false,
            model: {},
            url: {
                add: "/jeecg-engineering/inspection/inspectionDevice/add",
                edit: "/jeecg-engineering/inspection/inspectionDevice/edit",
                queryById: "/jeecg-engineering/inspection/inspectionDevice/queryById",
                // list: "null"
            },
            //地图
            // 定义地图数据
            BMap: "",
            map: "",
            center: { lng: 118.904, lat: 31.915 },//中心坐标
            centerPoint: { lng: 118.904, lat: 31.915 },
            zoom: 15, //初始缩放比
            scrollZoom: true,//允许鼠标滚轮缩放
            //折线颜色和标注icon
            colorAndIcon: [
                { lineColor: "#b083fb", icon: require("@/assets/daiban.png") },
                { lineColor: "#b08xab", icon: require("@/assets/duban.png") },
            ],
            iconList: {
              1: require("@/assets/inspectionImage/shuiyuan.png"),
              2: require("@/assets/inspectionImage/shuichang.png"),
              3: require("@/assets/inspectionImage/paishui.png"),
              6: require("@/assets/inspectionImage/beiyongshuiyuan.png"),
              7: require("@/assets/inspectionImage/shuibeng.png"),
              8: require("@/assets/inspectionImage/yuanlinlvhua.png"),
              9: require("@/assets/inspectionImage/jinggai.png"),
              12: require("@/assets/inspectionImage/shuibiao.png"),
              13: require("@/assets/inspectionImage/jiayabeng.png"),
              11: require("@/assets/inspectionImage/qibiao.png"),
              14: require("@/assets/inspectionImage/songfeng.png"),
              15: require("@/assets/inspectionImage/dian.png"),
              16: require("@/assets/inspectionImage/deng.png"),
              17: require("@/assets/inspectionImage/qiangji.png"),
              18: require("@/assets/inspectionImage/bianyazhan.png"),
            },
            //线路坐标信息
            lineMapList: [],
            //站点坐标信息
            stationMapList: [],
            searchAddresKeywords: '',
            localList: [],
            defaultOpen: false,
        }
    },
    computed: {
        validatorRules() {
            return {
                deviceType: [{ required: true, message: this.$t('请选择设备类型'), trigger: 'change' }],
                deviceName: [{ required: true, message: this.$t('请输入设备名称'), trigger: 'blur' }],
                deviceDetail: [{ required: true, message: this.$t('请输入设备描述'), trigger: 'blur' }],
                deviceNum: [{ required: true, message: this.$t('请输入设备编号'), trigger: 'blur' }],
                detectLongitude: [{ required: true, message: this.$t('请输入设备经度'), trigger: 'blur' }],
                detectLatitude: [{ required: true, message: this.$t('请输入设备纬度'), trigger: 'blur' }],
            }
        },
    },
    watch: {
        'model.detectLongitude': {
            handler(val) {
                if (!this.map) return; // 确保地图已初始化
                if (val && this.model.detectLatitude) {
                    var point = {
                        lng: val,
                        lat: this.model.detectLatitude
                    };
                    this.map && this.map.clearOverlays(); // 移除地图上的标注
                    var marker = new BMap.Marker(point); // 创建标注
                    this.map && this.map.addOverlay(marker); // 将标注添加到地图中
                    this.center = point;
                    // this.zoom = 13;
                    // this.map.centerAndZoom(point, 13);
                } else {
                    this.map && this.map.clearOverlays(); // 移除地图上的标注
                }
            }
        },
        'model.detectLatitude': {
            handler(val) {
                if (!this.map) return; // 确保地图已初始化
                if (val && this.model.detectLongitude) {
                    var point = {
                        lng: this.model.detectLongitude,
                        lat: val
                    };
                    this.map && this.map.clearOverlays(); // 移除地图上的标注
                    var marker = new BMap.Marker(point); // 创建标注
                    this.map && this.map.addOverlay(marker); // 将标注添加到地图中
                    this.center = point;
                    // this.zoom = 13;
                    // this.map.centerAndZoom(point, 13);
                } else {
                    this.map && this.map.clearOverlays(); // 移除地图上的标注
                }
            }
        },
    },
    methods: {
        // onSearch(val) {
        //     let that = this;
        //     var local = new BMap.LocalSearch(this.map, {
        //         //智能搜索
        //         onSearchComplete: function (results) {
        //             if (!results) {
        //                 that.localList = [];
        //             } else {
        //                 that.localList = results.as.splice(0, 5);
        //             }
        //             // let poi = results.getPoi(0); //获取第一个智能搜索的结果
        //             // var searchpt = poi.point; // 获取坐标
        //             // that.map.centerAndZoom(searchpt, 11);
        //             // that.center = searchpt;
        //             // that.localList.map(l=>{
        //             //   let cood = l.point;
        //             //   that.map.addOverlay(new BMap.Marker(cood)); //添加标注
        //             // });
        //         },
        //     });
        //     local.search(val);
        // },
        handleSearch(){
            let that = this;
            var local = new BMap.LocalSearch(this.map, {
                //智能搜索
                onSearchComplete: function (results) {
                    if(local.getStatus() == BMAP_STATUS_SUCCESS){
                        that.localList = [];      
                        for (var i = 0; i < results.getCurrentNumPois(); i ++){ 
                            that.localList.push({
                                uid:results.getPoi(i).uid,
                                title:results.getPoi(i).title,
                                address:results.getPoi(i).address,
                                point:results.getPoi(i).point
                            })
                        }
                        that.defaultOpen = true;
                        console.log("返回值",that.localList);
                    }
                },
            });
            local.search(this.searchAddresKeywords);
        },
        onSelect(value, option) {
            let select = this.localList.find(l => l.uid == value);
            let searchpt = select.point;
            this.$set(this, 'searchAddresKeywords', select.title);
            this.$set(this.model, 'detectLongitude', searchpt.lng);
            this.$set(this.model, 'detectLatitude', searchpt.lat);
            this.center = searchpt;
            this.map && this.map.clearOverlays();
            this.zoom = 15;
            this.map.centerAndZoom(searchpt, 15);
            this.map && this.map.addOverlay(new BMap.Marker(searchpt));
            this.defaultOpen = false;
        },
        add() {
            this.visible = true;
            this.model = {};
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
                this.mapReady({BMap:this.BMap,map:this.map})
            });
            this.searchAddresKeywords = '';
            this.localList = [];
        },
        edit(record) {
            this.visible = true;
            this.model = {};
            getAction(this.url.queryById, { id: record.id }).then((res) => {
                if (res.success) {
                    this.model = res.result;
                    this.mapReady({BMap:this.BMap,map:this.map})
                }else{
                    this.$message.warning(res.message);
                }
            });
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
            this.searchAddresKeywords = '';
            this.localList = [];
        },
        close() {
            this.$emit('close');
            this.visible = false;
            this.defaultOpen = false;
        },
        handleOk() {
            const that = this;
            // 触发表单验证
            this.$refs.form.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    let httpurl = '';
                    let method = '';
                    if (!this.model.id) {
                        httpurl += this.url.add;
                        method = 'post';
                    } else {
                        httpurl += this.url.edit;
                        method = 'put';
                    }
                    httpAction(httpurl, this.model, method).then((res) => {
                        if (res.success) {
                            that.$message.success(res.message);
                            that.$emit('ok');
                            this.visible = false;
                        } else {
                            that.$message.warning(res.message);
                        }
                    }).finally(() => {
                        that.confirmLoading = false;
                    })
                }

            })
        },
        handleCancel() {
            this.close()
        },
        //--------地图
        //地图默认方法
        mapReady({ BMap, map }) {
            let that = this;
            this.BMap = BMap;
            this.map = map;
            // 禁用地图的交互功能
            if (this.disableSubmit) {
                // map.disableDragging();
                // map.disableScrollWheelZoom();
                // map.disableDoubleClickZoom();
                // map.disablePinchToZoom();
                // map.disableKeyboard();
            } else {
                map.enableDragging();
                map.enableScrollWheelZoom();
                map.enableDoubleClickZoom();
                map.enablePinchToZoom();
                map.enableKeyboard();
            }
            var coordinate = {
                lng: this.model.detectLongitude,
                lat: this.model.detectLatitude,
                pf: "inner"
            };
            this.center = coordinate;
            // 新增时获取当前定位
            if (that.model&&!that.model.id) {
                let geolocation = new BMap.Geolocation();
                geolocation.getCurrentPosition(function (r) {
                    if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                        this.center = r.point;
                        // let mk = new BMap.Marker(r.point);
                        // map.addOverlay(mk);
                        if(!that.model.id) map.panTo(r.point);
                        console.log('当前位置：', r.point);
                    } else {
                        console.log('定位失败');
                    }
                }, { enableHighAccuracy: true })
            }else{
                map.panTo(coordinate);
            }
            var marker = new BMap.Marker(coordinate); // 创建标注
            map.addOverlay(marker); // 将标注添加到地图中

            this.drawMap();//适当地方调用
            
            // 点击地图添加监听事件获取经纬度
            if (!this.disableSubmit) {
                map.addEventListener("click", (e) => {
                    var clickpt = e.point;
                    this.$confirm({
                        title: this.$t("提示"),
                        content: (<div><div style="font-weight:bold;">{this.$t('经度：')}{clickpt.lng}</div><div style="font-weight:bold;">{this.$t('纬度：')}{clickpt.lat}</div><div>{this.$t('是否使用当前位置信息?')}</div></div>),
                        onOk() {
                            that.$set(that.model, 'detectLongitude', clickpt.lng);
                            that.$set(that.model, 'detectLatitude', clickpt.lat);
                            map.clearOverlays(); // 移除地图上的标注
                            var marker = new BMap.Marker(clickpt); // 创建标注
                            map.addOverlay(marker); // 将标注添加到地图中
                        },
                    })
                    // this.zoom = 15;
                    // this.map.centerAndZoom(clickpt, 15);
                });
            } else {
                map.removeEventListener("click");
            }
            
            //给地图添加鼠标移动事件
            map.addEventListener('mousemove', (e) => {
            //   const point = new BMap.Point(e.point.lng, e.point.lat);
            //   this.showInfoWindow(point);
            });

            // 搜索地址
            // var ac = new BMap.Autocomplete({
            //   input: "searchAddres",
            //   location: map,
            // });
            // ac.addEventListener("confirm", function (e) {debugger
            //   map.clearOverlays(); // 移除地图上的标注
            //   // var _value = e;
            //   // 		myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
            //   // 		G("searchResultPanel").innerHTML ="onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
            //   var local = new BMap.LocalSearch(map, {
            //     //智能搜索
            //     onSearchComplete: function (results) {
            //       let poi = results.getPoi(0); //获取第一个智能搜索的结果
            //       var searchpt = poi.point; // 获取坐标
            //       map.centerAndZoom(searchpt, 16);
            //       map.addOverlay(new BMap.Marker(searchpt)); //添加标注
            //       this.geocAddress(searchpt); // 逆地址解析
            //     },
            //   });
            //   // 搜索词
            //   var searchValue = e.item.value;
            //   local.search(
            //     searchValue.province +
            //       searchValue.city +
            //       searchValue.district +
            //       searchValue.street +
            //       searchValue.business
            //   );
            // });

        },
        /** 逆向解析地址 point */
        geocAddress(point) {
            debugger
            let that = this;
            var geoc = new BMap.Geocoder();
            geoc.getLocation(point, function (geocInfo) {
                // 设置基本信息
                var addressInfo = geocInfo.addressComponents;
                that.addressInfo.longitude = point.lng;
                that.addressInfo.latitude = point.lat;
                that.addressInfo.province = addressInfo.province;
                that.addressInfo.city = addressInfo.city;
                that.addressInfo.district = addressInfo.district;
                let address = addressInfo.street + addressInfo.streetNumber;
                if (geocInfo.surroundingPois.length > 0) {
                    address = address + geocInfo.surroundingPois[0].title;
                }
                that.addressInfo.address = address;
            });
        },
        drawMap() {
            let BMap = this.BMap;
            let map = this.map;
            let data = this.lineMapList; //线路
            let data2 = this.stationMapList; //站点

            // 这里是数据改变时，地图中心点定位到当前第一条数据的第一个坐标点或者默认的中心坐标
            // let point = data.length && data[0].length ? data[0][2] : this.centerPoint;
            // this.center = { lng: point.lng, lat: point.lat };

            // 线路坐标信息 数据类型：数组包数组
            for (let i = 0; i < data.length; i++) {
                let points = [];
                for (let j = 0; j < data[i].length; j++) {
                    points.push(new BMap.Point(data[i][j].lng, data[i][j].lat));
                }
                this.addPolyline(BMap, map, data, points, i);//调用添加折线方法
            }
            // 站点坐标信息 数据类型：数组包对象
            for (let i = 0; i < data2.length; i++) {
                let points = [];
                points.push(new BMap.Point(data2[i].lng, data2[i].lat));
                this.addStation(BMap, map, data2, points, i);//调用添加站点方法
            }
        },
        //添加折线
        addPolyline(BMap, map, data, points, index) {
            let _this = this; //注意this的使用
            let polyline = "";
            // 创建折线
            polyline = new BMap.Polyline(points, {
                enableEditing: false, // 是否启用线编辑，默认为false
                // 设置折线颜色,可以设置不同颜色线路，需要自己定义
                strokeColor: this.colorAndIcon[0].lineColor,
                strokeWeight: 9, // 折线宽度
                strokeOpacity: 1, // 折线透明度
            });
            map.addOverlay(polyline); // 将折线添加到地图
            //折线点击事件
            polyline.addEventListener("click", function (e) {
                //......
            });
            for (let j = 0; j < points.length; j++) {
                this.addMarker(
                    BMap,
                    map,
                    new BMap.Point(data[index][j].lng, data[index][j].lat),
                    j + 1,
                    index
                );
            }
        },


        //添加icon和标识
        addMarker(BMap, map, point, number, index) {
            let marker = "";//线体坐标点
            let label = "";//icon上的文字
            let myIcon = new BMap.Icon(
                //也可以设置不同坐标点上的icon，需要自己定义
                // this.colorAndIcon[0].icon,
                this.iconList[this.model.deviceType]||require("@/assets/inspectionImage/shuiyuan.png"),
                new BMap.Size(30, 30), //图标可视区域大小
                { anchor: new BMap.Size(8, 8) } //图标定位点相对于图标左上角的偏移量
            );
            myIcon.setImageSize(new BMap.Size(15, 15)); // 设置icon大小
            marker = new BMap.Marker(point, { icon: myIcon }); // 创建图像标注
            map.addOverlay(marker); // 将标注添加到地图
            //icon标识内容位置
            label = new BMap.Label(number, { offset: new BMap.Size(3, 0) });
            // 文本标识样式
            label.setStyle({
                fontWeight: 600,
                fontSize: "8px",
                color: "white",
                backgroundColor: "0",
                border: 0,
            });
            marker.setLabel(label); // 为icon添加文本标识
        },
        //站点数据处理  逻辑同上
        addStation(BMap, map, data, points, index) {
            for (let j = 0; j < points.length; j++) {
                this.addStationMarker(
                    BMap,
                    map,
                    new BMap.Point(data[index].lng, data[index].lat),
                    j + 1,
                    index
                );
            }
        },
        //添加站点标注
        addStationMarker(BMap, map, point, number, index) {
            let marker = "";
            let myIcon = new BMap.Icon(
                this.colorAndIcon[1].icon,
                new BMap.Size(30, 30),
                { anchor: new BMap.Size(8, 8) }
            );
            myIcon.setImageSize(new BMap.Size(18, 18));
            marker = new BMap.Marker(point, { icon: myIcon });
            map.addOverlay(marker);
        },
        showInfoWindow(point) {
          const infoWindow = new BMap.InfoWindow(`${this.$t('经度：')}${point.lng.toFixed(6)}<br>${this.$t('纬度：')}${point.lat.toFixed(6)}`);  // 创建信息窗口对象
          this.map.openInfoWindow(infoWindow, point); // 打开信息窗口
        }
    }
}
</script>
<style scoped lang="less">
/deep/.ant-modal {
    top: 5px;
    padding-bottom: 0;
}
</style>